<template>
  <div ref="app" id="app_top">
    <div className="app_content">
      <template v-if="auth0.isAuthenticated.value">
        <google-maps-loader :apiKey="GoogleMapsApiKey" id="mainmap">
          <InvalidCustomerChecker>

            <router-view />

          </InvalidCustomerChecker>
        </google-maps-loader>

        <WarningMessage v-if="computedWarningMessage" />
      </template>
      <template v-else-if="showRouterViewIfNotAuthenticated">
        <router-view /> <!-- pretty much LoginMenuView.vue -->
      </template>

      <Loading v-if="auth0.isLoading.value" label="Authenticating..." />
    </div>
  </div>

  <div id="jelenius_modal_container">
    <DialogContainer />
  </div>
</template>

<script setup>
import { ref, watch, computed, inject, provide, onMounted } from 'vue'
import { useAuth0 } from '@auth0/auth0-vue'
import { useStore } from 'vuex'
import { container as DialogContainer } from 'jenesius-vue-modal'
import { useRouter } from 'vue-router'

import GoogleMapsLoader from '@/components/maps/GoogleMapsLoader'
import WarningMessage from '@/components/WarningMessage'
import InvalidCustomerChecker from '@/components/InvalidCustomerChecker'
import Loading from '@/components/Loading'

const app = ref(null)
const auth0 = useAuth0()
const router = useRouter()

inject('$auth0', auth0)

const droppedFiles = ref([])
const env = inject('$env')
const store = useStore()

const GoogleMapsApiKey = env.VUE_APP_GOOGLE_MAPS_API_KEY

const computedWarningMessage = computed(() => {
  return store.state.warningMessage
})

const showRouterViewIfNotAuthenticated = computed(() => {
  const currentRouteName = router?.currentRoute?.value?.name || ''

  return "Login Menu" === currentRouteName
})

watch([auth0.isAuthenticated, auth0.isLoading], () => {
  if (auth0.isAuthenticated.value) {
    return
  }

  if (auth0.isLoading.value) {
    return
  }

  router.replace({ path: '/menu-login' })
}, { immediate: true })

//dispatch API to store?

provide('$auth', auth0)
provide('droppedFiles', droppedFiles)

onMounted(() => {
  const el = app.value

  let eventsToBlock = ['dragover']
  eventsToBlock.forEach((name) => {
    el.addEventListener(name, (e) => {
      e.preventDefault()
    })
  })

  el.addEventListener('drop', (e) => {
    e = e.originalEvent || e
    e.preventDefault()
    if (e.dataTransfer && e.dataTransfer.files) {
      droppedFiles.value = e.dataTransfer.files
    }
  })
})

onMounted(() => {

})
</script>

<style lang="css">
#app_top {
  flex-grow: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.app_content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.modal-container {
  background-color: var(--opaque-background-color);
}

#jelenius_modal_container {
  position: relative;
  z-index: var(--z-index-dialog);
}
</style>
